import React from 'react';
import App from './app/App';
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { HashRouter } from 'react-router-dom';
import { StripeProvider } from 'react-stripe-elements';
import store from './app/store';
import ScrollToTop from './app/ScrollToTop';
const hostname = window && window.location && window.location.hostname ? window.location.hostname : '';
const STRIPE_KEY = (hostname === 'app.postured.io') ? "pk_live_A3RU6sRwShycVQt62uGEaveU" : "pk_test_HalXOUjXBqBmtTcvatMI8pxa";


render(
  <Provider store={store}>
    <HashRouter>
      <ScrollToTop>
        <StripeProvider apiKey={STRIPE_KEY}>
          <App />
        </StripeProvider>
      </ScrollToTop>
    </HashRouter>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js